import PropTypes from 'prop-types';

import styles from './GridHeader.module.scss';

const GridHeader = ({ children }) => (
  <div className={styles.gridHeader}>
    <div className={styles.container}>{children}</div>
  </div>
);

GridHeader.propTypes = {
  children: PropTypes.node,
};

GridHeader.defaultProps = {
  children: '',
};

export default GridHeader;
